import { SHOW_COOKIE_NOTIFICATION, HIDE_COOKIE_NOTIFICATION } from '../modules/constants.js'

export const showNotification = () => {
  return { type: SHOW_COOKIE_NOTIFICATION  }
}

export const hideNotification = () => {
  return { type:  HIDE_COOKIE_NOTIFICATION  }
}